<template>
  <div class="index">
    <div class="flex justify-between">
      <!-- 星级评定结果 -->
      <div class="jieguo">
        <div class="jieguo-top" v-if="!last_star.message">
          <div class="jieguo-title">星级评定结果</div>
          <div class="jieguo-name">({{ last_star.org_name }}{{last_star.star_name}})</div>
          <div class="jieguo-detail">
            <div class="jieguo-xingji">
              <div class="title">
                <img src="@/assets/images/xingjipingdingjieguo.png" alt="">
              </div>
              <div class="rate">
                <el-rate
                  v-model="last_star.star"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </div>
            </div>
            <div class="jieguo-fenshu">
              <div class="jidu-box">
                <div class="fen">
                  <p>分数</p>
                  <b>{{ last_star.score }}</b>
                </div>
                <el-progress type="dashboard" :width="124" :stroke-width="18" :show-text="false" :percentage="last_star.score"></el-progress>
              </div>
              <div class="fenshutex">取最新一次评定结果</div>
              <div class="fenshu-btn" @click="lookStart">查看详情 <i class="iconfont icon-liulan1"></i></div>
            </div>
          </div>
        </div>
        <div class="jieguo-end" v-if="!last_star.message">
          <div class="title">
            <img src="@/assets/images/defenxaingqing.png" alt="">
          </div>
          <div class="head-tex">
            <span>指标</span>
            <span>得分率</span>
          </div>
          <div class="defen-item" v-for="item in last_star.score_percent" :key="item.name">
            <div class="defen-label">{{item.name}}</div>
            <div class="defen-value">
              <el-progress :percentage="item.percent" status="warning" :stroke-width="10" :show-text="false"></el-progress>
            </div>
            <div class="defen-num">{{item.percent}}%</div>
          </div>
        </div>
        <div class="jieguo-end height" v-if="last_star.message">
          <div class="tipstitle">{{last_star.message}}</div>
        </div>
      </div>
      <!-- 教培机构预警 -->
      <div class="yujing">
        <div class="yj-title">
          <div class="title-left">
            <div class="titleft-icon">
              <img src="@/assets/images/jiaopeijigouyujing.png" alt="">教培机构预警
            </div>
            <div class="titleft-more" @click="$router.push('/home/riskList')">
              <a href="">查看更多</a>
            </div>
          </div>
          <div class="title-right">
            <img src="@/assets/images/gantanhao.png" alt="">
          </div>
        </div>
        <div class="num-box">
          <div class="num-item gray">
            <div class="num-tit">信息提示</div>
            <div class="num-tex">共计<b> {{num.gray}} </b>条预警</div>
            <img src="@/assets/images/xinxitishiicon.png" alt="">
          </div>
          <div class="num-item yellow">
            <div class="num-tit">黄色预警</div>
            <div class="num-tex">共计<b> {{num.yellow}} </b>条预警</div>
            <img src="@/assets/images/huangseyujingicon.png" alt="">
          </div>
          <div class="num-item orange">
            <div class="num-tit">橙色预警</div>
            <div class="num-tex">共计<b> {{num.orange}} </b>条预警</div>
            <img src="@/assets/images/chengseyujingicon.png" alt="">
          </div>
          <div class="num-item red">
            <div class="num-tit">红色预警</div>
            <div class="num-tex">共计<b> {{num.red}} </b>条预警</div>
            <img src="@/assets/images/hongseyujingicon.png" alt="">
          </div>
        </div>
        <div class="tipslist">
          <el-table
            :data="tableData"
            :header-cell-style="centerbgc"
            :cell-style="textCenter"
            style="width: 100%">
            <el-table-column
              label="预警"
              width="100">
              <template slot-scope="scope">
                <div class="btn gray" v-if="scope.row.level == 0">提示</div>
                <div class="btn yellow" v-if="scope.row.level == 1">预警</div>
                <div class="btn orange" v-if="scope.row.level == 2">预警</div>
                <div class="btn red" v-if="scope.row.level == 3">预警</div>
              </template>
            </el-table-column>
            <el-table-column
              label="信息"
              prop="info"
              width="200">
            </el-table-column>
            <el-table-column
              prop="instruction"
              label="描述">
            </el-table-column>
            <el-table-column
              label="时间"
              prop="create_time"
              width="200">
            </el-table-column>
            <el-table-column
              label="天数"
              prop="day"
              width="80">
            </el-table-column>
            <el-table-column
              width="100"
              prop="status_txt"
              label="状态">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--  消息提醒-->
      <div class="notice">
        <div class="padding-right-sm padding-left-sm">
          <div class="title-content">
            <div class="title-icon">
              <img src="@/assets/images/xiaoxitixing.png" alt="">消息提醒
            </div>
            <div class="title-more pointer" @click="$router.push('/home/messageList')">查看更多<i class="iconfont icon-jiantou_yemian_xiangyou_o"></i></div>
          </div>
        </div>

        <div class="notice-list scroll" >
          <div class="notice-content">
            <div class="notice-item" v-for="item in messages" :key="item.id" @click="$router.push('/home/messageList')" :class="{active:item.read_time == 0}">
              <i></i>
              <p class="ovHide2">{{item.message}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="end-flex">
<!--      通知公告-->
      <div class="tongzhi">
        <div class="title-content">
          <div class="title-icon">
            <img src="@/assets/images/tongzhigonggao.png" alt="">通知公告
          </div>
          <div class="title-more blue pointer" @click="$router.push('/home/noticeList')">查看更多<i class="iconfont icon-jiantou_yemian_xiangyou_o"></i></div>
        </div>
        <div class="list">
          <div class="item" v-for="item in tongzhi" :key="item.id" @click="to('/home/detail',item.id,'通知公告')">
            <div class="tit ovHide2">{{item.title}}</div>
            <div class="time">{{item.publish_time}}</div>
          </div>
        </div>
      </div>
<!--      政策法规-->
      <div class="fagui">
        <div class="title-content">
          <div class="title-icon">
            <img src="@/assets/images/zhengcefagui.png" alt="">政策法规
          </div>
          <div class="title-more blue pointer" @click="$router.push('/home/policyList')">查看更多<i class="iconfont icon-jiantou_yemian_xiangyou_o"></i></div>
        </div>
        <div class="search">
          <input type="text" v-model="keyword" placeholder="关键词搜索">
          <img src="@/assets/images/souusobtn.png" alt="" @click="search">
        </div>
        <div class="list">
          <div class="item"  v-for="item in fagui" :key="item.id"  @click="to('/home/detail',item.id,'政策法规')">
            <div class="tit ovHide">{{item.title}}</div>
            <div class="tex ovHide">来源：{{item.resource}}</div>
            <div class="tex ovHide">时间：{{item.publish_time}}</div>
          </div>
        </div>
      </div>
<!--      宣传信息-->
      <div class="xuanc">
        <div class="title-content">
          <div class="title-icon">
            <img src="@/assets/images/xunchuanxinxi.png" alt="">宣传信息
          </div>
          <div class="title-more blue pointer" @click="$router.push('/home/publicizeNewsList')">查看更多 <i class="iconfont icon-jiantou_yemian_xiangyou_o"></i></div>
        </div>
        <div class="list">
          <div class="item" v-for="item in xuanchuan" :key="item.id" @click="to('/home/detail',item.id,'宣传信息')">
            <div class="item-img">
              <img :src="item.thumb" alt="">
            </div>
            <div class="item-tit ovHide">{{item.title}}</div>
            <div class="item-time">{{item.publish_time}}</div>
          </div>
        </div>
      </div>
    </div>
   </div>
</template>
<script>
import {imgUrl} from "@/config";
import {org_index, org_msglst} from "@/api";

export default {
  name: "index",
  data() {
    return {
      imgUrl:imgUrl,
      keyword: '',
      tableData:[],
      percentage: 10,
      fagui:[],
      tongzhi:[],
      xuanchuan:[],
      messages:[],
      last_star:{
        star_name:'',
        org_name:'',
        star_id:'',
        score: 0,
        star: 5,
        score_percent:[],
      },
      num: {
        gray: 0,
        orange: 0,
        yellow: 0,
        red: 0
      },
    }
  },
  components: {

  },
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 1
    })
    this.init()
  },
  mounted(){

  },
  methods: {
    async init(){
      let _data = await org_index();
      if(_data.status == 200) {
        this.fagui = _data.data.fagui
        this.tongzhi = _data.data.tongzhi
        this.xuanchuan = _data.data.xuanchuan
        this.last_star = _data.data.last_star
        this.num.gray = _data.data.warning.gray
        this.num.orange = _data.data.warning.orange
        this.num.yellow = _data.data.warning.yellow
        this.num.red = _data.data.warning.red
        this.tableData = _data.data.warning.list
      }
      let _res = await org_msglst(1,10)
      if(_res.status == 200) {
        this.messages = _res.data.data
      }

    },
    search(){
      this.$router.push({
        path: '/home/policyList',
        query: {
          keyword: this.keyword
        }
      })
    },
    lookStart(){
      this.$router.push({
        path: '/home/evaluateDetail',
        query: {
          id: this.last_star.star_id
        }
      })
    },
    to(path, id, name){
      this.$router.push({
        path: path,
        query: {
          id: id,
          name:name
        }
      })
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  .el-rate__icon {
    font-size: 28px;
  }
}
.index {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  .end-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;

    .tongzhi {
      width: 494px;
      height: 535px;
      background-image: linear-gradient(0deg,
        #ffffff 84%,
        #edf6ff 100%);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 0 20px;
      .list {
        width: 100%;
        height: 430px;
        margin-top: 20px;
        overflow: hidden;
        .item {
          width: 100%;
          border-bottom: solid 2px #e3e7f0;
          display: flex;
          justify-content: center;
          flex-direction: column;
          height: 110px;
          cursor: pointer;
          &:hover {
            .tit {
              font-size: 16px;
              color: #5198e2;
              font-weight: bold;
            }
          }
          .time {
            font-size: 14px;
            color: #999999;
            padding-top: 10px;
          }
          .tit {
            width: 100%;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
    .fagui {
      flex: 1;
      margin: 0 20px;
      width: 572px;
      height: 535px;
      background-image: linear-gradient(0deg,
        #ffffff 84%,
        #edf6ff 100%);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 0 20px;
      .search {
        width: 100%;
        height: 40px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #ededed;
        padding: 3px;
        display: flex;
        justify-content: flex-start;
        margin-top: 20px;
        img {
          margin-left: 30px;
          cursor: pointer;
        }
        input {
          flex: 1;
          margin-left: 30px;
          font-size: 14px;
          height: 34px;
          color: #333333;
        }
      }
      .list {
        width: 100%;
        height: 390px;
        margin-top: 5px;
        overflow: hidden;
        .item {
          width: 100%;
          height: 100px;
          padding-left: 22px;
          border-bottom: solid 2px #e3e7f0;
          display: flex;
          justify-content: center;
          flex-direction: column;
          position: relative;
          &:hover {
            color: #5198e2;
          }
          &:before{
            content: '';
            width: 6px;
            height: 6px;
            background-color: #dfe1f0;
            border-radius: 3px;
            position: absolute;
            top: 20px;
            left: 3px;
          }
          .tit {
            font-size: 16px;
            color: #16181d;
            font-weight: bold;
          }
          .tex {
            width: 100%;
            font-size: 14px;
            color: #999999;
            margin-top: 5px;
          }
        }
      }
    }
    .xuanc {
      width: 774px;
      height: 535px;
      background-image: linear-gradient(0deg,
        #ffffff 84%,
        #edf6ff 100%);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 0 20px;
      .list {
        width: 100%;
        height: 430px;
        margin-top: 20px;
        overflow: hidden;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .item {
          width: 224px;
          margin-bottom: 20px ;
          cursor: pointer;
          margin-right: 20px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          &:hover {
            .item-tit {
              color: #5198e2;
            }
          }
          .item-time {
            width: 100%;
            font-size: 14px;
            color: #a5a7ae;
            padding-top: 10px;
          }
          .item-tit {
            width: 100%;
            font-size: 16px;
            color: #16181d;
            padding-top: 8px;
          }
          .item-img {
            width: 100%;
            height: 139px;
            background-color: #f2f2f2;
            border-radius: 6px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .title-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    border-bottom: solid 2px #e3e7f0;
    .title-more {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      color: #f74945;
      padding-top: 7px;
      &.blue {
        color: #2791ff;
        i {
          color: #2791ff;
        }
      }
      i {
        color: #f74945;
        font-size: 16px;
        margin-top: -3px;
      }
    }
    .title-icon {
      display: flex;
      justify-content: flex-start;
      font-size: 20px;
      color: #16181d;
      font-weight: bold;
      padding-top: 24px;
      img {
        margin-left: -10px;
      }
    }
  }

  .notice {
    width: 348px;
    height: 519px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #ffeded 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;

    .notice-list {
      width: 100%;
      height: 420px;
      overflow-y: auto;
      margin-top: 20px;
      .notice-content {
        padding: 0 20px;
        width: 100%;
        height: max-content;
        padding-bottom: 50px;
      }
      .notice-item {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        //height: 54px;
        margin-bottom: 20px;
        &.active {
          i {
            background-color: #f44a47;
          }
          p {
            color: #fa7573;
          }
        }
        p {
          flex: 1;
          width: 0;
          font-size: 16px;
          color: #9da0a7;
          padding-left: 10px;
        }
        i {
          width: 8px;
          height: 8px;
          background-color: #dfe1f0;
          border-radius: 4px;
          margin-top: 9px;
        }
      }
    }
  }

  .yujing {
    flex: 1;
    margin: 0 20px;
    width: 998px;
    height: 520px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #ffe8e8 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 18px;
    .tipslist{
      width: 100%;
      height: 290px;
      margin-top: 20px;
      overflow: hidden;
      .desc {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #64676d;
        &.color {
          color: #2791ff;
        }
      }
      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;
        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }
        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }
        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }
        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }

    }
    .num-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-top: 5px;
      .num-item {
        width: 225px;
        flex: 1;
        height: 111px;
        padding: 20px;
        margin-right: 20px;
        position: relative;
        >img {
          position: absolute;
          right: 0;
          bottom: 0;
        }
        &.red {
          background: url('../../../assets/images/hongseyujingbgc.png') no-repeat;
          background-size: 100% 100%;
          margin-right: 0;
          .num-tit {
            color: #f8001a;
          }
          .num-tex {
            color: #666666;
            b {
              color: #f8001a;
            }
          }
        }
        &.orange {
          background: url('../../../assets/images/chengseyujingbgc.png') no-repeat;
          background-size: 100% 100%;
          .num-tit {
            color: #f58739;
          }
          .num-tex {
            color: #666666;
            b {
              color: #f58739;
            }
          }
        }
        &.yellow {
          background: url('../../../assets/images/huangseyujingbgc.png') no-repeat;
          background-size: 100% 100%;
          .num-tit {
            color: #fad471;
          }
          .num-tex {
            color: #666666;
            b {
              color: #fad471;
            }
          }
        }
        &.gray {
          background: url('../../../assets/images/xinxitishibgc.png') no-repeat;
          background-size: 100% 100%;
          .num-tit {
            color: #8a8a8a;
          }
          .num-tex {
            color: #666666;
            b {
              color: #8a8a8a;
            }
          }
        }
        .num-tex {
          width: 100%;
          font-size: 16px;
          font-weight: bold;
          b {
            font-size: 24px;
            font-weight: bold;
          }
        }
        .num-tit {
          width: 100%;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
    .yj-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title-right {
        padding-top: 18px;
        margin-left: 4px;
      }

      .title-left {
        flex: 1;
        height: 60px;
        border-bottom: 1px solid #e3e7f0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .titleft-more {
          padding-top: 20px;
          a {
            font-size: 14px;
            color: #f74945;
          }
        }
        .titleft-icon {
          display: flex;
          justify-content: flex-start;
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          padding-top: 20px;
          img {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .jieguo {
    width: 494px;
    height: 519px;
    background-image: linear-gradient(0deg,
      #e1eeff 0%,
      #83c0ff 50%,
      #2791ff 100%);
    border-radius: 10px;
    border: solid 1px #f6f7fa;
    padding: 20px;
    .jieguo-end {
      width: 100%;
      height: 269px;
      background: url('../../../assets/images/pingdingdfenbgc.png') no-repeat;
      background-size: 100% 100%;
      margin-top: 15px;
      padding: 20px;
      &.height {
        height: 450px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .tipstitle {
          width: 100%;
          padding: 0 20px;
          text-align: center;
          font-size: 26px;
          font-weight: bold;
          color: #e37a0a;
        }
      }
      .defen-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        .defen-label {
          width: 80px;
          font-size: 14px;
          color: #999999;
          font-weight: bold;
        }
        .defen-num {
          width: 60px;
          font-size: 14px;
          color: #999999;
          font-weight: bold;
          text-align: right;
        }
        .defen-value {
          flex: 1;

        }
      }
      .head-tex {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 10px;
        span {
          font-size: 14px;
          color: #2791ff;
        }
      }
    }
    .jieguo-top {
      width: 100%;
      height: 200px;
      position: relative;
      .jieguo-detail {
        width: 100%;
        height: 190px;
        background: url("../../../assets/images/xingjipingdingjieguofenshubgc.png") no-repeat bottom center;
        position: absolute;
        left: 0;
        top: 10px;
        padding-right: 32px;
        display: flex;
        justify-content: space-between;
        .jieguo-fenshu {
          width: 152px;
          height: 190px;

          padding: 18px 0;
          .jidu-box {
            width: 100%;
            display: flex;
            justify-content: center;
            height: 70px;
            //border: 1px solid #000;
            position: relative;
            .fen {
              width: 100%;
              height: 70px;
              position: absolute;
              left: 0;
              top: 34px;
              p {
                display: block;
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #2791ff;
              }
              b {
                display: block;
                width: 100%;
                text-align: center;
                font-size: 28px;
                color: #2791ff;
                line-height: 28px;
                font-weight: bold;
              }
            }
          }
          .fenshutex {
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #8a8a8a;
            margin-top: 40px;
          }
          .fenshu-btn {
            width: max-content  ;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #2791ff;
            cursor: pointer;
            margin: 0 auto;
            i {
              font-size: 20px;
              color: #2791ff;
              margin-left: 4px;
            }
          }
        }
        .jieguo-xingji {
          width: 240px;
          padding: 0 15px;
          padding-top: 75px;
        }
        .rate {
          width: 100%;
          padding-top: 26px;
          .iconfont {
            font-size: 30px;
            color: #f8c001;
            margin-right: 10px;
          }
        }
      }
      .jieguo-title {
        width: 260px;
        font-size: 20px;
        color: #ffffff;
        font-weight: bold;
      }
      .jieguo-name {
        width: 260px;
        font-size: 14px;
        color: #ffffff;
        opacity: 0.8;
        padding-top: 3px;
        line-height: 16px;
      }
    }
  }
}
</style>


